import React, { useEffect, useState } from "react"

import { Row, Col, CardBody, Card, Form, FormFeedback, Label } from "reactstrap"

//redux
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import OTPInput from "react-otp-input"
import logo from "../../assets/images/logo-light1.svg"
import {
  useWealthPartnerResendOTPMutation,
  useWealthPartnerVerifyLoginOTPMutation,
} from "store/api/wealthpartnerapi/auth/auth.api"
import {
  useInvestorResendOTPMutation,
  useInvestorVerifyLoginOTPMutation,
} from "store/api/investorapi/auth.api"
import { setLoginUserData } from "store/slices/userSlice"
import { userTypes } from "helpers/utils"

const TwoFactor = () => {
  //meta title
  document.title = "Two Factor | Prachay"

  const { token } = useParams()
  const { accountType } = useSelector((state) => state.common)
  const [onVerifyinvestor, { isLoading }] = useInvestorVerifyLoginOTPMutation()
  const [onVerifyWealth, { isLoading: onVerifying }] =
    useWealthPartnerVerifyLoginOTPMutation()

  const [onResendinvestor, { isLoading: resending }] =
    useInvestorResendOTPMutation()
  const [onResendWealth, { isLoading: onResending }] =
    useWealthPartnerResendOTPMutation()
  const counterTime = 60
  const [counter, setCounter] = useState(counterTime)

  const dispatch = useDispatch()
  const history = useNavigate()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { token, otp: "" },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      handleVerify(values)
    },
  })

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [counter])

  const handleVerify = async (params) => {
    try {
      const { data, success } =
        accountType === "INVESTOR"
          ? await onVerifyinvestor(params).unwrap()
          : await onVerifyWealth(params).unwrap()
      dispatch(
        setLoginUserData({
          userType: userTypes[accountType],
          user: data.user,
          permissions: data.user.permissions,
          auth: true,
          jwt: data.tokens.access.token,
        })
      )
      history("/dashboard")
    } catch (error) {
      if (error.status === 404) {
        history("/login")
      }
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const handleResendOtp = async () => {
    try {
      const { message } =
        accountType === "INVESTOR"
          ? await onResendinvestor({ token }).unwrap()
          : await onResendWealth({ token }).unwrap()

      validation.setFieldValue("otp", null)
      setCounter(counterTime)
      toast.success(message, { id: "toastMessage" })
    } catch (error) {
      if (error.status === 404) {
        history("/login")
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <div className="account-pages">
      <Row className="g-0">
        <Col md={7} lg={7} xl={7} className="p-0 m-0">
          <div className="log-in-blue-bg-cover">
            <div className="login-page-text">
              <h4>Managing your</h4>
              <h5>
                <span> CORPORATE TREASURY </span> was never so easy
              </h5>
              <p>Introducing Prachay ICDs</p>
            </div>
            <div className="login-page-bottom-text">
              <h4>DON'T LEAVE</h4>
              <h5>
                YOUR <span style={{ color: "#f0a634" }}>SURPLUS </span>{" "}
                UNMANAGED
              </h5>
            </div>
          </div>
        </Col>

        <Col md={5} lg={5} xl={5}>
          <div className="overflow-hidden login-form-wrapper px-1">
            <Card>
              <CardBody>
                <Link to="/" className="p-2">
                  <img src={logo} alt="" height="50" />
                </Link>
                <div className="login-text">
                  <h4>Two Factor !</h4>
                  <p>Please enter otp sent on your email address.</p>
                </div>

                <div className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div>
                        <Label className="form-label">Enter OTP</Label>
                        <div
                          className={`${validation.errors.otp && "is-invalid"}`}
                        >
                          <OTPInput
                            onChange={(val) => {
                              validation.setFieldValue("otp", val)
                            }}
                            shouldAutoFocus
                            inputType={"number"}
                            inputStyle={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "10px",
                              border: "1px solid #ddd",
                            }}
                            containerStyle={{
                              display: "flex",
                              gap: "15px",
                            }}
                            value={validation.values.otp || ""}
                            numInputs={6}
                            renderInput={(props) => <input {...props} />}
                          />
                        </div>
                        {validation.errors.otp ? (
                          <FormFeedback type="invalid">
                            {validation.errors.otp}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div
                        className="text-start mt-2"
                        style={{
                          color: "#a9a9a9",
                        }}
                      >
                        {counter > 0 && (
                          <p>
                            {`Didn't receive the OTP? Resend OTP in ${counter} sec`}
                          </p>
                        )}
                        {counter <= 0 && (
                          <div
                            style={{
                              color: "#035ca1",
                              cursor: "pointer",
                            }}
                            onClick={() => handleResendOtp()}
                            // cursor={"pointer"}
                            // color={Colors.text.black}
                          >
                            {resending || onResending ? (
                              <Spinners
                                color="dark"
                                className="align-items-center justify-content-start"
                              />
                            ) : (
                              "Resend OTP"
                            )}
                          </div>
                        )}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block position-relative"
                          type="submit"
                          disabled={isLoading || onVerifying}
                        >
                          {isLoading || onVerifying ? (
                            <Spinners />
                          ) : (
                            "Verify OTP"
                          )}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default withRouter(TwoFactor)
